<script lang="ts">
    import {onDestroy, onMount} from 'svelte';

    export let scaleMultiplier = 1.75;
    export let minimalScale = 0.85;
    export let opacityMultiplier = 0.5;

    let randomX = 0;
    let randomY = 0;
    let opacity = 0;
    let scale = 0;

    let hidden = false;
    let animationReversed = false;
    let repositionTimeout: number | undefined;

    onMount(() => {
        regenerateValues();
        repositionTimeout = window.setTimeout(reposition, Math.random() * 3500 + 3500);
    });

    onDestroy(() => {
        if (repositionTimeout) {
            window.clearTimeout(repositionTimeout);
        }
    });

    function reposition() {
        hidden = true;

        setTimeout(() => {
            regenerateValues();

            setTimeout(() => {
                hidden = false;
                repositionTimeout = window.setTimeout(reposition, Math.random() * 3500 + 3500);
            }, 200);
        }, 600);
    }

    function regenerateValues() {
        randomX = Math.floor(Math.random() * 100);
        randomY = Math.floor(Math.random() * 100);
        opacity = Math.random() * opacityMultiplier + 0.25;
        scale = Math.max(opacity * scaleMultiplier, minimalScale);
        animationReversed = Math.random() > 0.5;
    }
</script>

<div class="floating-icon"
     class:hidden-icon={hidden}
     style="opacity: {opacity}; scale: {scale}; top: {randomY}%; left: {randomX}%; animation-direction: {animationReversed ? 'reverse' : 'normal'}">

    <slot/>
</div>

<style lang="less">
    .floating-icon {
        position: absolute;
        animation: fly 8s linear infinite;
        transition: scale 0.6s ease-in-out, opacity 0.6s ease-in-out;

        &.hidden-icon {
            scale: 0 !important;
            opacity: 0 !important;
        }
    }

    @keyframes fly {
        0% {
            transform: rotate(0deg) translate(-50%) rotate(0deg);
        }
        100% {
            transform: rotate(360deg) translate(-50%) rotate(-360deg);
        }
    }
</style>